import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateRoleEntity } from '../../domain/entities/CreateUpdateRoleEntity'

export class CreateUpdateRoleModel extends CreateUpdateRoleEntity {
  policyIds?: Array<number> | null
  constructor(dataDto: CreateUpdateRoleEntity) {
    super()
    mapEntityProperties<CreateUpdateRoleModel>(this, dataDto, {
      exclude: ['policies'],
      map: {
        policyIds: dataDto.policies?.map((policy) => policy.id)
      }
    })
  }
}
